import { formatDayOfMonthWithYear } from "@clipboard-health/date-time";

import { type CompatibleColor, getCompatibleColor } from "../../internal/getCompatibleColor";
import { Text, type TextProps } from "../Text";

export interface AsOfDateTextProps extends Omit<TextProps, "color"> {
  date: Date;
  color?: CompatibleColor;
}

/**
 * This component is used to confirm that whatever content it is paired with is up to date as of
 * provided date.
 */
export function AsOfDateText(props: AsOfDateTextProps) {
  const { color, variant = "caption", date, ...textProps } = props;

  return (
    <Text
      variant={variant}
      sx={(theme) => ({
        color: getCompatibleColor({
          color,
          defaultColor: theme.palette.text.secondary,
          theme,
        }),
      })}
      {...textProps}
    >
      As of {formatDayOfMonthWithYear(date)}
    </Text>
  );
}
